import { Alert, AlertDescription, AlertIcon, AlertTitle, CloseButton } from '@chakra-ui/react';
import useOnlineStatus from '@rehooks/online-status';

import { spacing } from '@/styles/ui.theme';

type Props = {
  children: React.ReactElement;
};

const OnlineStatus = ({ children }: Props): React.ReactElement => {
  const onlineStatus = useOnlineStatus();

  if (!onlineStatus) {
    return (
      <>
        <Alert status='error' mb={spacing.gutter}>
          <AlertIcon />
          <AlertTitle mr={2}>OFFLINE</AlertTitle>
          <AlertDescription>
            Eita, parece que a nossa conexão caiu... Vamo torcer pra voltar logo!
          </AlertDescription>
          <CloseButton position='absolute' right='8px' top='8px' />
        </Alert>
        {children}
      </>
    );
  }

  return children;
};

export default OnlineStatus;
